import React from 'react'
import travelli1 from  './images/travelli1.JPG';
import travelli2 from  './images/travelli2.JPG';
import travelli3 from  './images/travelli3.JPG';
import review1 from  './images/review1.png';
import review2 from  './images/review2.png';
import review3 from  './images/review3.png';
import review4 from  './images/review4.png';


export default function PicsForm () {
  return (
    <div>
  <section id="pics" className="container-fluid">
    <div id="pic1">
      <img
        src={travelli1}
        className="rounded mx-auto d-block"
        alt=""
      />
    </div>
    <div id="pic2">
      <img src={travelli2} className="" alt="" />
    </div>
    <div id="pic3">
      <img src={travelli3} alt="" />
     
    </div>
    <div id="welcome">
        <h1 id="welcome-text" className="">
          Welcome to Find ,Flights,Hotels &amp; Tour Packages
          <span className="text-success">Cheap rate</span>
        </h1>
        <p className="mt-5 fs-5 w-75">
          Rebuilt for simplicity and speed, so you can spend more time
          discovering and listening to great podcasts.
        </p>
      </div>
  </section>
  <section id="customers" className="w-100">
    <div className="container-fluid pt-3 row" id="customers-row">
      <div id="reviews" className="d-flex col-lg-7">
        <ul id="review-images" className="list-unstyled d-flex">
          <li>
            <img id="im1" src={review1} alt="" />
          </li>
          <li>
            <img id="im2" src={review2} alt="" />
          </li>
          <li>
            <img id="im3" src={review3} alt="" />
          </li>
          <li>
            <img id="im4" src={review4} alt="" />
          </li>
        </ul>
        <div id="star">
          <h5 className="text-light">Our Happy Customers</h5>
          <span className="text-light">
            <i className="fa-solid fa-star text-warning" />
            4.9(1.5k Reviews)
          </span>
        </div>
      </div>
      <div className="col-lg-5 d-flex  gap-1">
        <div id="users" className="d-flex gap-3 text-light">
          <i className="fas fa-users fs-1 mt-4" />
          <h3 className="my-auto">
            12
            <span className="fs-5">Years Experience</span>
            <span className="fs-2">|</span>
          </h3>
        </div>
        <div id="users" className="d-flex gap-3 text-light">
          <i className="fa-solid fa-award fs-1 mt-4" />
          <h3 className="my-auto">
            12
            <span className="fs-5">Awards Gained</span>
          </h3>
        </div>
      </div>
    </div>
  </section>
  <section id="form-inputs" className="mx-auto justify-content-center ">
  <div className="d-md-flex flex-md-row  gap-3  py-2 container" id="form">
    <div className="box-item">
      <h3 className="box-title">Where</h3>
      <form className="search-form">
        <input
          type="text"
          id="text"
          className="form-control"
          placeholder="Center Point, Lo..."
        />
      </form>
    </div>
    <div className="">
      <h3 className="">From - To</h3>
      <input type="date" name="daterange" className="form-control" />
    </div>
    <div className="box-item">
      <h3 className="box-title">Guests</h3>
      <select
        className=" form-control pointer"
        name="Guests"
        id="Guests-select"
      >
        <option>01</option>
        <option>02</option>
        <option>03</option>
        <option>04</option>
      </select>
    </div>
    <div className="box-item align-self-end">
      <a href="/" className="btn btn-success d-block">
        Search Plan
      </a>
    </div>
  </div>
</section>

    </div>
  )
}
